










import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    inheritAttrs: false,
    model: {
        prop: 'value',
        event: 'change',
    },
})
export default class CCheckbox extends Vue {
    @Prop({required: true}) value!: boolean;
    @Prop({default: true, type: Boolean}) showChangeState!: boolean;
    @Prop() initialValue!: boolean | undefined;
    @Prop({default: 'plywood lighten-1', type: String}) color!: string;

    private localInitialValue: boolean | null = null;

    get checkboxClasses() {
        const classes: string[] = [];
        if (this.realInitialValue != this.value && this.showChangeState) classes.push('changed');
        return classes;
    }

    get listeners() {
        return Object.assign({}, this.$listeners, {
            change: (value: any) => this.$emit('change', value),
            input: (value: any) => this.$emit('input', value),
        });
    }

    get realInitialValue() {
        return typeof this.initialValue != 'undefined' ? this.initialValue : this.localInitialValue;
    }

    created() {
        this.localInitialValue = this.value;
    }
}
